/**
 * Erbij boeken op een cadeaubon of klanttegoed: tot € 1.000 (GIFTCARD_MAX_CENTS in
 * core/rules/kassa.ts). Boven dit bedrag vraagt het formulier eerst "Weet je het zeker?".
 */
export const BIG_TOPUP_CENTS = 25_000
